export enum LinxShowcaseType {
  CATEGORY = 'category',
  PRODUCT = 'product',
  SEARCH = 'search',
  HOME = 'home',
}

export enum DeviceType {
  DESKTOP = 'desktop',
  MOBILE = 'mobile',
}
